<template lang="html">
  <div class="">
    <v-window v-model="window">
      <v-window-item key="0">
        <v-container
          grid-list-xl
          fluid
          pa-6
        >
          <!-- <v-layout wrap>
            <v-flex xs12 mb-2 class="headline">Feedback</v-flex>
          </v-layout> -->
          <v-layout
            row
            wrap
          >
            <v-flex
              v-for="(ratings, calculatorId) in calculatorStats.calculator"
              :key="calculatorId"
              xs12
              sm6
              lg4
            >
              <v-card>
                <v-card-text class="pa-0">
                  <v-layout
                    align-center
                    ma-0
                    mb-n5
                  >
                    <v-sheet
                      class="v-sheet--offset ml-5 pa-5 shrink"
                      color="yellow darken-2"
                      style="top:-16px"
                      elevation="8"
                    >
                      <!-- max-width="72" -->
                      <!-- <v-icon color="white" large>star</v-icon> -->
                      <span class="text-uppercase white--text title">{{ calculatorId }}</span>
                    </v-sheet>
                    <v-spacer />
                  </v-layout>
                  <v-layout
                    mx-0
                    align-center
                  >
                    <v-flex xs12>
                      <v-layout
                        v-for="rating in filteredRatings(ratings)"
                        :key="rating.id"
                        align-center
                        ma-0
                      >
                        <v-rating
                          readonly
                          small
                          :value="_calculateRating(rating)"
                          color="yellow darken-2"
                          background-color="grey"
                        /> <span class="ml-2">{{ rating.id.charAt(0).toUpperCase() + rating.id.slice(1) }}</span>
                      </v-layout>
                    </v-flex>
                    <v-flex>
                      <div class="display-2">
                        <SiTweenNumber
                          :value="_calculateRating(ratings.overall)"
                          :format="v => Number(v).toFixed(2)"
                        />
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-data-table
          :headers="tableHeaders"
          :items="feedbackSorted"
          sort-by="timestamp"
          sort-desc
          :items-per-page="15"
          class="cursor-pointer"
          @click:row=" item => $router.push(`feedback/${item.id}`)"
        >
          <template #item.rating="{ item }">
            <v-layout align-center>
              <v-icon
                left
                color="yellow darken-2"
              >
                star
              </v-icon> {{ item.rating }}
            </v-layout>
          </template>
          <template #item.timestamp="{ item }">
            <span class="text-no-wrap">{{ _formatDateTime(Number(item.timestamp)) }}</span>
          </template>
          <template #item.for="{ item }">
            <v-layout ma-0>
              <v-icon class="mr-2">
                {{ forTextIcons(item.for).icon }}
              </v-icon>
              {{ item.forId }}
            </v-layout>
          </template>
        </v-data-table>
      </v-window-item>

      <v-window-item key="1">
        <si-container back="/feedback">
          <v-flex xs12>
            <v-card>
              <v-container
                fluid
                pa-4
              >
                <v-layout wrap>
                  <v-flex xs12>
                    <div class="caption grey--text">
                      Date
                    </div>
                    <div>{{ _formatDateTime(Number(fbItem.timestamp)) }}</div>
                  </v-flex>
                  <v-flex xs12>
                    <div class="caption grey--text">
                      For
                    </div>
                    <v-layout
                      align-center
                      ma-0
                    >
                      <v-btn
                        v-if="fbItemLink"
                        :to="fbItemLink"
                        text
                        color="primary"
                      >
                        <v-icon left>
                          {{ forTextIcons(fbItem.for).icon }}
                        </v-icon> {{ forTextIcons(fbItem.for).label }}
                      </v-btn>
                      <span v-else><v-icon left>{{ forTextIcons(fbItem.for).icon }}</v-icon> {{ forTextIcons(fbItem.for).label }}</span>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <div class="caption grey--text">
                      Ratings
                    </div>
                    <v-layout
                      align-center
                      ma-0
                    >
                      <v-rating
                        readonly
                        :value="overallRating(fbItem.ratings).value"
                        color="yellow darken-2"
                        background-color="grey"
                      /> {{ Number(overallRating(fbItem.ratings).value).toFixed(1) }} <span class="ml-2">Overall</span>
                    </v-layout>
                    <v-layout
                      v-for="rating in otherRatings(fbItem.ratings)"
                      :key="rating.id"
                      align-center
                      ma-0
                    >
                      <v-rating
                        readonly
                        :value="rating.value"
                        color="yellow darken-2"
                        background-color="grey"
                      /> {{ Number(rating.value).toFixed(1) }} <span class="ml-2">{{ rating.label }}</span>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <div class="caption grey--text">
                      Feedback
                    </div>
                    <div>
                      {{ fbItem.text }} <i
                        v-if="!fbItem.text"
                        class=" grey--text text--lighten-2"
                      >no comment</i>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <div class="caption grey--text">
                      Email (if supplied)
                    </div>
                    <div>
                      <a :href="`mailto:${fbItem.email}`">{{ fbItem.email }}</a> <i
                        v-if="!fbItem.email"
                        class=" grey--text text--lighten-2"
                      >no email</i>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <div class="caption grey--text">
                      Metadata
                    </div>
                    <div>
                      <i
                        v-if="!fbItem.meta"
                        class=" grey--text text--lighten-2"
                      >no metadata</i>
                      <v-layout
                        v-for="(meta, metaKey) in fbItem.meta"
                        :key="metaKey"
                      >
                        <v-flex
                          shrink
                          mr-2
                        >
                          {{ metaKey }}:
                        </v-flex>
                        <v-flex>{{ meta }}</v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </si-container>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { forEach } from 'lodash'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import analytics from '@/mixins/analytics'

export default {
  mixins: [ helpers, binder, analytics ],
  props: {

  },
  data () {
    return {
      feedback: {},
      calculatorStats: {},
      tableHeaders: [
        { text: 'Rating', value: 'rating', width: 80 },
        { text: 'Ratings', value: 'ratingCount', width: 50 },
        { text: 'Date', value: 'timestamp', width: 150 },
        { text: 'For', value: 'for', width: 40 },
        { text: 'Text', value: 'text' }
      ]
    }
  },
  computed: {
    ...mapGetters(['_calculators']),
    window () {
      return this.$route.params.sub ? 1 : 0
    },
    feedbackSorted () {
      return this._sortObject(this.feedback, 'timestamp').map(f => {
        return {
          id: f.id,
          for: f.for,
          forId: f.forId,
          ratingCount: Object.keys(f.ratings || {}).length,
          timestamp:
          f.timestamp,
          rating: (f.ratings || {}).overall,
          text: f.text }
      })
    },
    fbItem () {
      let id = this.$route.params.sub
      return this.feedback[id] || {}
    },
    fbItemLink () {
      let { for: isFor, meta = {} } = this.fbItem || {}
      if (isFor === 'calculator' && meta.calculationId) return `/calculations/${meta.calculatorId}/${meta.calculationId}`
      return null
    },
    fbItemMeta () {
      let { for: isFor, meta = {} } = this.fbItem || {}
      let formattedMeta = {}
      forEach(meta, (m, k) => {
        formattedMeta[k] = this.formatMeta(m, k, meta, isFor)
      })
      return formattedMeta
    }
  },
  watch: {
    calculatorStats () {
      console.log(this.calculatorStats);
      
    }
  },
  beforeMount () {
    this.$bindRtdb('feedback', `/feedback/ratings`, { loader: true })
    this.$bindRtdb('calculatorStats', `/stats/ratings`)
    // this.$bindxxx(rtdb.ref(`/feedback/ratings`), 'feedback', true)
    // this.$bindxxx(rtdb.ref(`/stats/ratings`), 'calculatorStats')
    this.$store.commit('set_appBarTitle', { title: 'Feedback', icon: 'star' })
  },
  methods: {
    formatMeta (value, key, meta, isFor) {
      let link = null
      if (isFor === 'calculator' && key === 'calculationId') link = `/calculations/${meta.calculatorId}/${meta.calculationId}`
      return { value, link }
    },
    forTextIcons (isFor) {
      let mappings = {
        calculator: { label: 'Calculation', icon: 'assessment' }
      }
      return mappings[isFor] || {}
    },
    otherRatings (ratings = {}) {
      const label = (s) => {
        const rg = /(^\w{1}|\.\s*\w{1})/gi
        return s.replace(rg, s => s.toUpperCase())
      }

      return Object.entries(ratings)
        .filter(([k]) => k !== 'overall')
        .map(([k, v]) => ({ label: label(k), value: v }))
    },
    overallRating (ratings = {}) {
      let value = ratings.overall
      return { label: 'Overall', value }
    },
    filteredRatings (ratings) {
      return this._sortObject(ratings).sort(r => r.id === 'overall' ? -1 : 1)
    }
  }
}
</script>

<style lang="css" scoped>

</style>
